import InstantSearchWrapper from "../components/layout/Search/InstantSearchWrapper";

const data = [
  {
    img: "https://images.steelcase.com/image/upload/v1640134274/www.steelcase.com/2021/12/22/21-0171032.png",
    caption: "Customer's Own Material",
    description: `
    Our Customer’s Own Material (COM) program allows you to tailor Steelcase furniture and seating products for a customized look. Select Steelcase seating and furniture products accommodate hundreds of textiles from many leading fabric suppliers. With the customer’s own material web tool, you can find a textile that is already approved on your product, or you can submit a request to have a new one tested. \n
    Once you have selected an approved textile, use one of the calculators to find out the exact yardage required. Click the link below for further instructions.
    `,
    link: "https://srh.steelcase.com/comlanding.aspx"
  },
  {
    img: "https://images.steelcase.com/image/upload/v1633645929/www.steelcase.com/2021/10/07/21-0159286.png",
    caption: "Open Line Laminate",
    description: `
    Our Open Line Laminate (OLL) program allows you to tailor Steelcase furniture products for a customized look. Select Steelcase furniture products accommodate hundreds of laminates from the leading laminate suppliers. With the open line laminate web tool, you can find a laminate that is already approved on your product, or you can submit a request to have a new one tested. \n
    Once you have selected an approved laminate, use the calculator to find out the exact number of sheets required. Click the link below for further instructions.
    `,
    link: "https://srh.steelcase.com/olllanding.aspx"
  },
  {
    img: "https://images.steelcase.com/image/upload/v1640134291/www.steelcase.com/2021/12/22/21-0171031.png",
    caption: "PerfectMatch Paint",
    description: `
    Our PerfectMatch program allows you to get Steelcase painted products in virtually any color you choose. With the PerfectMatch web tool, customers can submit a request to have a unique paint color created to literally whatever sample they want to. \n
    To get started with the process, submit the online test request form and follow the easy steps by clicking the link below.
    `,
    link: "https://srh-authenticated.steelcase.com/pmlanding.aspx"
  },
  {
    img: "https://images.steelcase.com/image/upload/v1640134240/www.steelcase.com/2021/12/22/21-0171034.png",
    caption: "Customiz Stain",
    description: `
    Our Customiz Stain program offers you the opportunity to specify a custom-matched stain in a Steelcase wood environment. With the Customiz Stain web tool, customers can find a stain that is already approved on their product, or they can submit a request to have a stain color tested and approved that is unique to them.
    To get started with the process, just submit the online test request form and follow the easy steps by clicking the link below.
    `,
    link: "https://srh-authenticated.steelcase.com/customizelanding.aspx"
  }
]
interface COMProps {
  indexName: string;
}

export default function CustomerMaterials({indexName}: COMProps) {
    return (
      <InstantSearchWrapper indexName={indexName}>
        <div className={"fl-container__flex fl-container__content"} style={{ marginTop: "20px", marginBottom: "20px" }}>
          <div className={"finish-overview__header"}>
            <h2>Customize your Product</h2>
            <p>Our Custom programs allow you to tailor Steelcase furniture and seating products for a customized solution.</p>
          </div>
          <div className={"com-cards__container"}>
            {
              data.map((item, idx) => {
                return (
                  <div className={"com-cards__card-category"} key={idx}>
                    <a href={item.link} target="_blank" rel="noopener noreferrer">
                      <div className={"com-cards__card-image-wrapper"}>
                        <img src={item.img} />
                      </div>
                      <div className={"com-cards__caption"}>
                        {item.caption}
                      </div>
                    </a>
                  </div>
                )
              })
            }
          </div>

          <div className={"com-cards__container-vertical"}>

            {
              data.map((item) => {
                return (
                  <div className={"com-cards-vertical__container"}>
                    <div className={"com-cards__card-image-wrapper com-cards__card-image-wrapper--9-4-ratio com-cards__card-image-wrapper--1-2"}>
                      <img src={item.img} />
                    </div>
                    <div className={"com-cards__content-container"}>
                      <div className={"com-cards__title"}>
                          {item.caption}
                      </div>
                      <div className={"com-cards__content"}>
                        <p>{item.description}</p>
                      </div>
                      <div className={"com-cards__launch-wrapper"}>
                        <a className={"com-cards__launch-button"} href={item.link} target="_blank" rel="noopener noreferrer">Launch</a>
                      </div>
                    </div>
                  </div>
                )
              })
            }
            

          </div>
        </div>
      </InstantSearchWrapper>
    )
}